import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import VnButton from '@ui/components/VnButton';
import { IonIcon } from '@ionic/react';
import { calendarOutline, glassesOutline } from 'ionicons/icons';
import VnValidation from '@ui/components/VnValidation';
import { selectStyles } from '@ui/styles/select-style';
import VnSelectText from '@ui/components/VnSelectText';
import { useParams } from 'react-router-dom';
import { getAllArticalsAsync, getAllArticlesAsync, getArticalByIdAsync } from '@application/features/articles/ArticleThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllBrandsAsync } from '@application/features/brands/BrandThunk';
import { createMaterialAsync, deleteMaterialAsync, getHoursAndMaterialByIDAsync, updateMaterialAsync } from '@application/features/materials/MaterialThunk';
import moment from 'moment';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { getDateWithoutTime, handleRolePermission } from '@infrastructure/helpers';
import ModalPopup from '@ui/components/VnModal';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import VnPagination from '@ui/components/VnPagination';
import ArticleTableForm from '../../ArticleTableForm';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { NumericFormat } from 'react-number-format';
const AddHoursAndMaterialForm = ({ onClose, hoursAndMaterialId, disableWorkOrder, isHoursAndMaterialTabBold }) => {
    const { setValue, handleSubmit, register, watch, control, clearErrors, formState: { errors } } = useForm({
        defaultValues: {
            date: new Date(),
            netPrice: 0
        }
    });
    const dispatch = useAppDispatch();
    const { ArticlesDropDown, Articles, articles } = useAppSelector((state) => state.artical);
    const { brandsBrandLableDropdown, brandsUnitDropdown } = useAppSelector((state) => state.brands);
    // const initialRender = useRef(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const { id } = useParams();
    const [articleNumber, setArticleNumber] = useState('');
    const [selectedArticalId, setSelectedArticalId] = useState('');
    const [brand, setBrand] = useState('');
    const [hoursandmaterialDate, setHoursandmaterialDate] = useState(new Date());
    const [hoursAndMaterialDatePickerOpen, setHoursAndMaterialDateIsOpen] = useState(false);
    const [isDeleteConformOpen, setIsDeleteConformOpen] = useState(false);
    const [isArticleTableOpen, setIsArticleTableOpen] = useState(false);
    const quantity = watch('quantity');
    const sellingPrice = watch('sellingPrice');
    const [showArticleGridHeader] = useState(true);
    const defaultSortingCriteria = {
        sortColumnKey: 'articleNumber',
        sortDirection: 'desc'
    };
    const [articlesFilterValues, setArticlesFilterValues] = useState({
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        articleNumber: null,
        name: null,
        articleGroup: null,
        brand: null,
        type: null,
        data: null,
        supplierName: null,
        unit: null,
        supplierArticleNumber: null,
        grossPrice: null,
        discount: null,
        netPrice: null,
        sellingPrice: null,
        priceDate: null,
        stock: null
    });
    useEffect(() => {
        if (quantity && sellingPrice) {
            const total = quantity * sellingPrice;
            setValue('totaaldebrag', total);
        }
        else {
            setValue('totaaldebrag', 0);
        }
    }, [quantity, sellingPrice]);
    const grossPrice = watch('grossPrice');
    const netPrice = watch('netPrice');
    const discount = watch('discount');
    useEffect(() => {
        if (id) {
            dispatch(getAllArticalsAsync());
            dispatch(getAllBrandsAsync);
        }
    }, [dispatch, id]);
    useEffect(() => {
        if (hoursAndMaterialId > 0) {
            setArticleNumber('');
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setValue('date', new Date());
            setValue('data', '');
            setValue('supplierArticleNumber', '');
            setValue('unit', '');
            setValue('grossPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('sellingPrice', 0);
            setValue('group', '');
            setValue('quantity', 0);
            setHoursandmaterialDate(null);
            dispatch(getHoursAndMaterialByIDAsync(hoursAndMaterialId))
                .unwrap()
                .then((res) => {
                const articalName = Articles?.find((x) => x.articleNumber === res.articleNumber)?.name;
                if (res.articleNumber && res.articleNumber.trim() !== '' && articalName && articalName.trim() !== '') {
                    setArticleNumber(res.articleNumber + ' - ' + articalName);
                }
                else {
                    setArticleNumber(res.articleNumber ?? '');
                }
                setSelectedArticalId(res.articleId?.toString() ?? '');
                setValue('name', res.name);
                setValue('type', res.type);
                setValue('date', res.date);
                setHoursandmaterialDate(moment(res.date).toDate());
                setBrand(res.brand ?? '');
                setValue('group', res.group);
                setValue('data', res.data);
                setValue('supplierArticleNumber', res.supplierArticleNumber);
                setValue('quantity', res.quantity);
                setValue('unit', res.unit);
                setValue('grossPrice', res.grossPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
                setValue('sellingPrice', res.sellingPrice);
            });
        }
    }, [dispatch, hoursAndMaterialId]);
    const DeleteMaterial = (Id) => {
        setIsDeleteConformOpen(true);
    };
    const onSubmit = (data) => {
        data.date = getDateWithoutTime(data.date);
        if (id && hoursAndMaterialId === 0) {
            data.workOrderId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(createMaterialAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
            });
        }
        else if (id && hoursAndMaterialId > 0 && !disableWorkOrder) {
            data.id = hoursAndMaterialId;
            data.workOrderId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(updateMaterialAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
            });
        }
    };
    function onArticalNumberChange(selectedValue, selectedLable) {
        setArticleNumber(selectedLable);
        setSelectedArticalId(selectedValue);
        if (selectedValue && selectedValue !== '') {
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setValue('date', new Date());
            setHoursandmaterialDate(moment(new Date()).toDate());
            setValue('data', '');
            setValue('supplierArticleNumber', '');
            setValue('unit', '');
            setValue('grossPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('sellingPrice', 0);
            setValue('group', '');
            setValue('quantity', 0);
            setHoursandmaterialDate(null);
            dispatch(getArticalByIdAsync(parseInt(selectedValue)))
                .unwrap()
                .then((res) => {
                setValue('name', res.name);
                setValue('type', res.type);
                setBrand(res.brand ?? '');
                setValue('brand', res.brand ?? '');
                setValue('supplierArticleNumber', res.supplierArticleNumber);
                setValue('unit', res.unit);
                setValue('grossPrice', res.grossPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
                setValue('sellingPrice', res.sellingPrice);
                setValue('date', res.priceDate ? res.priceDate : new Date());
                setHoursandmaterialDate(res.priceDate ? moment(res.priceDate).toDate() : new Date());
            });
        }
    }
    function onBrandChange(selectedValue, selectedLable) {
        setBrand(selectedLable);
        setValue('brand', selectedLable);
    }
    const handleDeliveryDateChange = (date) => {
        setHoursandmaterialDate(moment(date).toDate());
        setValue('date', date);
        setHoursAndMaterialDateIsOpen(false);
    };
    const openHoursAndMaterialDatePicker = () => {
        setHoursAndMaterialDateIsOpen(!hoursAndMaterialDatePickerOpen);
    };
    function onCancelDeleteClicked() {
        setIsDeleteConformOpen(false);
    }
    function onDeleteClicked() {
        if (hoursAndMaterialId > 0) {
            dispatch(deleteMaterialAsync(hoursAndMaterialId))
                .unwrap()
                .then((res) => {
                onClose();
                setIsDeleteConformOpen(true);
            });
        }
    }
    const updateArticlesFilterValues = (newValues) => {
        setArticlesFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchArticleHandler(searchText) {
        updateArticlesFilterValues({ filter: searchText });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function articlesSortingHandler(data) {
        updateArticlesFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function articlesFilteringHandler(data) {
        data.pageNumber = 1;
        updateArticlesFilterValues(data);
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            ...data
        }));
    }
    useEffect(() => {
        dispatch(getAllArticlesAsync(articlesFilterValues));
    }, []);
    function onArticlesPageChange(pageNumber) {
        updateArticlesFilterValues({ pageNumber });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            pageNumber
        }));
    }
    const handleAddArticleRowClick = (data) => {
        const currentDate = new Date();
        const date = data.priceDate ? data.priceDate : currentDate;
        if (id && data) {
            const updatedArticleRowData = {
                ...data,
                workOrderId: parseInt(id),
                id: 0,
                date: date
            };
            const articalName = Articles?.find((x) => x.articleNumber === updatedArticleRowData.articleNumber)?.name;
            if (updatedArticleRowData.articleNumber &&
                updatedArticleRowData.articleNumber.trim() !== '' &&
                articalName &&
                articalName.trim() !== '') {
                setArticleNumber(`${updatedArticleRowData.articleNumber} - ${articalName ?? ''}`);
            }
            else {
                setArticleNumber(updatedArticleRowData.articleNumber ?? '');
            }
            setSelectedArticalId(updatedArticleRowData.articleId?.toString() ?? '');
            setValue('name', updatedArticleRowData.name);
            setValue('type', updatedArticleRowData.type);
            setValue('date', updatedArticleRowData.date);
            setHoursandmaterialDate(moment(updatedArticleRowData.date).toDate());
            setBrand(updatedArticleRowData.brand ?? '');
            setValue('group', updatedArticleRowData.group);
            setValue('data', updatedArticleRowData.data);
            setValue('supplierArticleNumber', updatedArticleRowData.supplierArticleNumber);
            setValue('quantity', updatedArticleRowData.quantity);
            setValue('unit', updatedArticleRowData.unit);
            setValue('grossPrice', updatedArticleRowData.grossPrice);
            setValue('discount', updatedArticleRowData.discount);
            setValue('netPrice', updatedArticleRowData.netPrice);
            setValue('sellingPrice', updatedArticleRowData.sellingPrice);
            // dispatch(createMaterialAsync(updatedArticleRowData))
            //     .unwrap()
            //     .then((res) => {
            //         dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id!)))
            //         .unwrap()
            //         .then((res) => {
            //          if (isHoursAndMaterialTabBold && res.length>0) {
            //             isHoursAndMaterialTabBold(true);
            //         }
            //         else{
            //             isHoursAndMaterialTabBold && isHoursAndMaterialTabBold(false);
            //         }
            //     });
            //     });
        }
    };
    //---------------Handling bruto,korting,neto and vekop price logic-----------------------
    const triggerUpdatedPricesLogic = () => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
        }
    };
    useEffect(() => {
        if (!isInitialLoad) {
            if (grossPrice && discount) {
                // Case 2: When both gross price and discount change, calculate net price and set selling price
                const calculatedNetPrice = grossPrice - (grossPrice * discount) / 100;
                setValue('netPrice', calculatedNetPrice);
                setValue('sellingPrice', grossPrice);
            }
            if (grossPrice && !discount) {
                //case 1 When gross price changes, set selling price and clear net price
                setValue('sellingPrice', grossPrice);
                setValue('netPrice', grossPrice);
            }
        }
    }, [grossPrice, discount, isInitialLoad]);
    useEffect(() => {
        if (!isInitialLoad) {
            if (!grossPrice && !discount && netPrice) {
                // Case 3: When only net price changes, calculate selling price as net price + 30%
                const calculatedSellingPrice = (netPrice / 70) * 100;
                setValue('sellingPrice', calculatedSellingPrice);
            }
        }
    }, [netPrice, isInitialLoad]);
    //---------------End of region handling bruto,korting,neto and vekop price logic-----------------------
    return (_jsxs(_Fragment, { children: [_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: isArticleTableOpen ? 'vn-hide' : 'Vn-form-FormMain', noValidate: true, children: [_jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Artikelnummer" }), _jsx(VnSelectText, { valueOptions: ArticlesDropDown, value: articleNumber, onOptionChange: onArticalNumberChange, listtype: 'articleNumber', placeHolder: 'Selecteer artikelnummer' })] }), _jsxs("div", { className: 'form-group col-md-6 mt-3', children: [_jsx("label", { className: 'form-label vn-text-label' }), !hoursAndMaterialId && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-4', icon: glassesOutline, onClick: () => {
                                            setIsArticleTableOpen(true);
                                        }, children: "Zoek Artikelen" }))] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Naam" }), _jsx("input", { id: 'name', type: 'text', placeholder: 'Voer naam in', className: 'form-control vn-Input', ...register('name') })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Merk" }), _jsx(VnSelectText, { lableOptions: brandsBrandLableDropdown, value: brand, onOptionChange: onBrandChange, listtype: 'brand', placeHolder: 'Selecteer merk' })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Type" }), _jsx("input", { id: 'type', type: 'text', placeholder: 'Voer type in', className: 'form-control vn-Input', ...register('type') })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Groep" }), _jsx("input", { id: 'group', type: 'text', placeholder: 'Voer groep in', className: 'form-control vn-Input', ...register('group') })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Datum" }), _jsx(Controller, { name: 'date', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: 'This field is required.'
                                            }
                                        }, render: () => (_jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { className: 'form-control vn-Input', onInputClick: openHoursAndMaterialDatePicker, open: hoursAndMaterialDatePickerOpen, onClickOutside: openHoursAndMaterialDatePicker, placeholderText: '', peekNextMonth: true, showPopperArrow: true, dropdownMode: 'select', dateFormat: 'dd/MM/yyyy', selected: hoursandmaterialDate, onChange: handleDeliveryDateChange, onKeyDown: (e) => {
                                                        e.preventDefault();
                                                    } }), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openHoursAndMaterialDatePicker }) })] })) }), _jsx(VnValidation, { fieldError: errors.date })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-md-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Gegevens" }), _jsx("textarea", { className: 'vn-Input', ...register('data'), style: { height: 150, width: '100%', borderRadius: '3px' } }), _jsx(VnValidation, { fieldError: errors.data })] }) }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Artikel Leveranciers" }), _jsx(Controller, { name: 'supplierArticleNumber', control: control, render: ({ field: { onChange, value } }) => (_jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer artikel Leveranciers in', value: value || '', onChange: (e) => onChange(e.target.value) })) }), _jsx(VnValidation, { fieldError: errors.supplierArticleNumber })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Aantal" }), _jsx(Controller, { name: 'quantity', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer aantal in', value: value || '', onValueChange: ({ value }) => {
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Eenheid" }), _jsx(Controller, { name: 'unit', control: control, render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Eenheid', isSearchable: true, styles: selectStyles, value: brandsUnitDropdown?.find((c) => c.label === value), options: brandsUnitDropdown && brandsUnitDropdown, onChange: (val) => onChange(val?.label) })) })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Bruto Prijs" }), _jsx(Controller, { name: 'grossPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { placeholder: 'Voer bruto prijs in', className: 'form-control vn-Input', value: value || '', onValueChange: ({ value }) => {
                                                if (value != grossPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                    setValue('sellingPrice', 0);
                                                    setValue('netPrice', 0);
                                                }
                                                else {
                                                    const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    if (regex.test(inputValue) || inputValue === '') {
                                                        onChange(inputValue);
                                                    }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Korting" }), _jsx(Controller, { name: 'discount', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer korting in', value: value || '', onValueChange: ({ value }) => {
                                                if (value != discount?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    if (regex.test(inputValue) || inputValue === '') {
                                                        onChange(inputValue);
                                                    }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 100) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Netto Prijs" }), _jsx(Controller, { name: 'netPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { disabled: !grossPrice && !discount ? false : true, className: 'form-control vn-Input', placeholder: '', value: value || '', onValueChange: ({ value }) => {
                                                if (value != netPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                    if (!grossPrice && !discount) {
                                                        setValue('sellingPrice', 0);
                                                    }
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Verkoopprijs" }), _jsx(Controller, { name: 'sellingPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer verkoopprijs in', value: value || '', onValueChange: ({ value }) => {
                                                if (value != sellingPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Totaal Bedrag" }), _jsx(Controller, { name: 'totaaldebrag', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { disabled: true, className: 'form-control vn-Input', placeholder: '', value: value?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), onValueChange: ({ value }) => {
                                            const inputValue = value;
                                            if (inputValue === '') {
                                                onChange(null);
                                            }
                                            else {
                                                onChange(inputValue);
                                            }
                                        }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false })) })] }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', isDisabled: !disableWorkOrder ? false : true, children: "Annuleren" }), hoursAndMaterialId > 0 ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => DeleteMaterial(hoursAndMaterialId), isDisabled: handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Delete) && !disableWorkOrder
                                                ? false
                                                : true, children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Update) && !disableWorkOrder
                                                ? false
                                                : true, children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Create) && !disableWorkOrder
                                        ? false
                                        : true, children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDeleteConformOpen }), _jsx(ModalPopup, { title: 'Zoek Artikelen', content: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showArticleGridHeader, onSearch: searchArticleHandler }), _jsx(ArticleTableForm, { OnAddArticlePopupClose: () => setIsArticleTableOpen(false), onAddMaterialPopupClose: () => { }, articals: articles?.items, onSorting: articlesSortingHandler, onFilter: articlesFilteringHandler, defaultSortingCriteria: defaultSortingCriteria, onRowClick: handleAddArticleRowClick }), _jsx("div", { className: 'mt-3', children: articles && (_jsx(VnPagination, { currentPage: articles?.pageNumber, totalPages: articles?.totalPages, onPageChange: onArticlesPageChange })) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsx("div", { style: { display: 'flex', marginLeft: 'auto' }, children: _jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: () => {
                                        // onClose();
                                        setIsArticleTableOpen(false);
                                    }, type: 'button', children: "Annuleren" }) }) })] }), onOpen: isArticleTableOpen, onClose: () => {
                    setIsArticleTableOpen(false);
                    // onClose();
                }, modalWidth: 'xl' })] }));
};
export default AddHoursAndMaterialForm;
